import React from "react";
import { Container, Col, Row, Form, Button, Image } from "react-bootstrap";
import contact from '../assets/img/contact.jpg'

function Contact() {
  return (
    <div>
      <Container>
        <Row className="rgc-orderform gx-5 gy-3">
          <Col xs={12}>
            <div className="d-flex rgc-title">
              <div className="rgc-title-point"></div>
              <h4>ارتباط با <span>پشتیبانی</span></h4>
            </div>
           </Col>
 
              <Col xs={11} className="mb-3 text-center">
                <Image src={contact} alt="contact" className="img-fluid my-4" style={{ height: "13em" }} />
                <div className="rgc-contact-txt">
                  <i className="fa-solid fa-phone-flip fa-beat"></i>
                  <span>شماره تماس:</span>
                  <span>09101011293</span>
                </div>

              </Col>

              {/* <Col xs={11} md={6} className="mb-3">
                
                <section>
                  <div className="container py-5">

                    <div className="row d-flex justify-content-center">
                      <div className="col-xl-12">
                        <div className="card">
                          <div className="card-header d-flex justify-content-between align-items-center p-3"
                            style={{borderTop:"4px solid #ffa900"}}>
                            <h5 className="mb-0">گفتگو با پشتیبانی</h5>
                            <div className="d-flex flex-row align-items-center">
                              <span className="badge bg-warning me-3">20</span>
                              <i className="fas fa-minus me-3 text-muted fa-xs"></i>
                              <i className="fas fa-comments me-3 text-muted fa-xs"></i>
                              <i className="fas fa-times text-muted fa-xs  p-1"></i>
                            </div>
                          </div>
                          <div className="card-body" data-mdb-perfect-scrollbar="true" style={{position:"relative",height:"400px"}}>

                            <div className="d-flex justify-content-between">
                              <p className="small mb-1">ادمین</p>
                              <p className="small mb-1 text-muted">23 Jan 2:00 pm</p>
                            </div>
                            <div className="d-flex flex-row justify-content-start">
                              <i className="fa fa-user-circle" />
                              <div>
                                <p className="small p-2 ms-3 mb-3 rounded-3" style={{backgroundColor:"#f5f6f7"}}>
                                 سلام
                                 چطور میتونم کمکتون کنم؟
                                 </p>
                              </div>
                            </div>

                            <div className="d-flex justify-content-between">
                              <p className="small mb-1 text-muted">23 Jan 2:05 pm</p>
                              <p className="small mb-1">کاربر</p>
                            </div>
                            <div className="d-flex flex-row justify-content-end mb-4 pt-1">
                              <div>
                                <p className="small p-2 me-3 mb-3 text-white rounded-3 bg-warning">
                                  سلام
                                  میخواستم بپرسم چطور میتونم امتیازم رو به دوستم انتقال بدم
                                </p>
                              </div>
                              <i className="fa fa-user-circle" />
                            </div>

                            <div className="d-flex justify-content-between">
                              <p className="small mb-1">ادمین</p>
                              <p className="small mb-1 text-muted">23 Jan 5:37 pm</p>
                            </div>
                            <div className="d-flex flex-row justify-content-start">
                              <i className="fa fa-user-circle" />
                              <div>
                                <p className="small p-2 ms-3 mb-3 rounded-3" style={{backgroundColor:"#f5f6f7"}}>
                                 شما میتونید قسمت راهنمای اپلیکیشن رو مطالعه کنید
                                 </p>
                              </div>
                            </div>

                            <div className="d-flex justify-content-between">
                              <p className="small mb-1 text-muted">23 Jan 6:10 pm</p>
                              <p className="small mb-1">کاربر</p>
                            </div>
                            <div className="d-flex flex-row justify-content-end mb-4 pt-1">
                              <div>
                                <p className="small p-2 me-3 mb-3 text-white rounded-3 bg-warning">
                                  متشکرم
                                  </p>
                              </div>
                              <i className="fa fa-user-circle" />
                            </div>

                          </div>
                          <div className="card-footer text-muted d-flex justify-content-start align-items-center p-3">
                            <div className="input-group mb-0">
                              <input type="text" className="form-control" placeholder="Type message"
                                aria-label="Recipient's username" aria-describedby="button-addon2"
                                style={{
                                borderTopLeftRadius: "0",
                                borderBottomLeftRadius: "0"}}
                                />

                              <button className="btn btn-warning"
                               type="button" 
                              id="button-addon2"
                               style={{paddingTop:"0.55rem",
                               borderTopRightRadius: "0",
                               borderBottomRightRadius: "0"}}>
                                ارسال
                              </button>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </section>
             </Col> */}

        </Row>
      </Container>
    </div>
  );
}

export default Contact;
